module.exports = __webpack_public_path__ + "static/img/gl11.af6ef98.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/gl11.png
// module id = /IH2
// module chunks = 3